<template>
  <CRow class="mb-0 mt-0">
    <CCol>
      <div>
        <CRow class="mb-0">
          <CCol sm="12" md="3" class="col-form-label font-bold">
            Время работы
          </CCol>
        </CRow>
        <CCardBody class="p-0">
          <CRow class="pl-3 pb-3 m-0">
            <div class="table-responsive">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th class="working-hours_fix-table">Начало работы</th>
                    <th class="working-hours_fix-table">Окончание работы</th>
                    <th class="working-hours_fix-table">Круглосуточно</th>
                    <th class="working-hours_fix-table">Активен</th>
                    <th class="working-hours_fix-table"></th>
                    <th class="working-hours_fix-table"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in slots" :key="item.id">
                    <td class="working-hours_fix-table">{{ scheduleFormated(item.open_weekday, item.open_hours, item.open_minutes) }}</td>
                    <td class="working-hours_fix-table">{{ scheduleFormated(item.close_weekday, item.close_hours, item.close_minutes) }}</td>
                    <td class="working-hours_fix-table">
                      <CBadge :color="getBadge(item.around_the_clock)">
                        &nbsp;{{item.around_the_clock ? 'Да' : 'Нет' }}&nbsp;
                      </CBadge>
                    </td>
                    <td class="working-hours_fix-table">
                      <CBadge :color="getBadge(item.enabled)">
                        &nbsp;{{item.enabled ? 'Да' : 'Нет' }}&nbsp;
                      </CBadge>
                    </td>
                    <td class="working-hours_fix-table" align="right"></td>
                    <td v-if="item.stop_until" class="store-schedule-warn__text">
                      {{ getTimeRemaining(item.stop_until) }}
                    </td>
                    <td v-else></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </CRow>
        </CCardBody>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import { cilPlus, cilTrash, cilPencil } from '@coreui/icons';
import moment from 'moment';

export default {
  name: 'WorkingHours',

  icons: {
    cilPlus,
    cilTrash,
    cilPencil,
  },

  props: {
    workingHours: {
      type: Array,
      default: () => [],
    },
    serviceType: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isAuthorized: false,
      editModal: false,
      editSchedule: {},
      weekdays: [
        { value: 1, label: 'понедельник' },
        { value: 2, label: 'вторник' },
        { value: 3, label: 'среда' },
        { value: 4, label: 'четверг' },
        { value: 5, label: 'пятница' },
        { value: 6, label: 'суббота' },
        { value: 0, label: 'воскресенье' },
      ],
      slots: [],
    };
  },

  async mounted() {},

  watch: {
    workingHours: function () {
      this.setModel();
    },
  },

  created() {
    this.setModel();
  },

  methods: {
    getTimeRemaining(date) {
      const dt = moment(date);
      if (moment().isSameOrBefore(dt)) {
        return `Приостановлен до ${dt.format('HH:mm')}`;
      }
      return '';
    },
    setModel() {
      this.slots = this.workingHours;
    },
    create() {
      this.editSchedule = {
        entity_id: +this.$route.params.id,
        open_weekday: 0,
        open_hours: 0,
        open_minutes: 0,
        close_weekday: 0,
        close_hours: 0,
        close_minutes: 0,
        enabled: false,
        around_the_clock: false,
        sort: 0,
        id: null,
      };
      this.editModal = true;
    },
    edit(item) {
      this.editSchedule = JSON.parse(JSON.stringify(item));
      this.editModal = true;
    },
    scheduleFormated(weekDay, hours, minutes) {
      weekDay = this.weekdays.find((item) => item.value === weekDay).label;
      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      return `${weekDay} - ${hours}:${minutes}`;
    },
    getBadge(status) {
      return status ? 'success' : 'secondary';
    },
  },
};
</script>

<style scoped>
.working-hours_fix-table {
  padding-right: 30px;
}
.store-schedule-warn__text {
  color: red;
  font-weight: bold;
}
@media (max-width: 767px) {
  .table-responsive {
    overflow-x: auto;
    display: block;
    width: 100%;
  }
  .pl-3 {
    padding-left: 0 !important;
  }
  .pb-3 {
    padding-bottom: 0 !important;
  }
  .working-hours_fix-table {
    padding-right: 10px;
  }
}

.table {
  width: 50% !important;
}
</style>